import React, { useEffect, useState } from 'react';
import { ExamSwitchScreen } from 'src/features';
import { useQuestions } from 'src/services';
import { queryParserSSR, withRedux } from '@utils';
import { size } from 'lodash';
import { wrapper } from '@store';
import { NextSeo } from 'next-seo';
import { useRouter } from 'next/router';

const MyExam = () => {
  // const { type } = router.query; get questions with type params from api
  const [answers, setAnswers] = useState<any>([]);
  const [questions, setQuestions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { getQuestions } = useQuestions();
  const router = useRouter();

  useEffect(() => {
    getQuestions(queryParserSSR(router))
      .then((res) => {
        console.log(res.data)
        setQuestions(res.data);
        setLoading(false);
        setAnswers(Array.apply(null, [...Array(size(res.data))]));
      })
      .catch((e) => e);
  }, []);
  return (
    <>
      <NextSeo
        title={`Sınavım - ${process.env.NEXT_PUBLIC_SITENAME}`}
        description={process.env.NEXT_PUBLIC_DESCRIPTION}
        canonical={process.env.NEXT_PUBLIC_SEO_HOST}
        openGraph={{
          type: 'website',
          url: process.env.NEXT_PUBLIC_SEO_HOST,
          site_name: process.env.NEXT_PUBLIC_SITENAME,
          title: 'Sınavım',
          description: 'Sınavım',
          images: [{ url: `${process.env.NEXT_PUBLIC_HOST}/images/common/og-default.png` }],
        }}
      />
      <ExamSwitchScreen loading={loading} answers={answers} setAnswers={setAnswers} questions={questions} />
    </>
  );
};

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  withRedux(
    async () => {
      return { props: {} };
    },
    { store },
  ),
);

export default MyExam;
